import { ICupom } from "shared/interfaces/ICupom";
import { api } from "../api";

/* =====================================================
   CRIAR CUPOM
   POST /coupons
===================================================== */

export const criarNovoCupom = async (
  dadosCupom: ICupom): Promise<ICupom> => {
  try {
    const response = await api.post<ICupom>("/coupons", dadosCupom);
    return response.data;
  } catch (error: any) {
    console.error("Erro ao criar cupom:", error?.response?.status);
    console.error("BODY:",error?.response?.data);
    throw error;
  }
};


/* =====================================================
   CUPONS GLOBAIS
===================================================== */

export const buscarCuponsGlobais = async (): Promise<ICupom[]> => {
  try {
    const response = await api.get(`/coupons/`);

    return response.data.map((cupom: any) => ({
      uid: cupom.id,
      ...cupom,
    }));
  } catch (error) {
    console.error(error);

    return [];
  }
};

/* =====================================================
   CUPONS DO USUÁRIO
===================================================== */

export const buscarCuponsPorUsuario = async (): Promise<ICupom[]> => {
  try {
    const response = await api.get(`/coupons`);

    return response.data.map((cupom: any) => ({
      uid: cupom.id,
      ...cupom,
    }));
  } catch (error) {
    console.error(error);

    return [];
  }
};

/* =====================================================
   TODOS OS CUPONS
===================================================== */

export const buscarTodosCupons = async (): Promise<ICupom[]> => {
  const [globais, pessoais] = await Promise.all([
    buscarCuponsGlobais(),
    buscarCuponsPorUsuario(),
  ]);

  return [...globais, ...pessoais];
};

/* =====================================================
   BUSCAR CUPONS ATIVOS
   GET /coupons
===================================================== */

export const buscarCupons = async (): Promise<ICupom[]> => {
  try { const response = await api.get<ICupom[]>("/coupons");
    return response.data;
  } catch (error: any) {
    console.error("Erro ao buscar cupons:", error?.response?.status);
    console.error("BODY:",error?.response?.data);
    throw error;
  }
};
/* =====================================================
   BUSCAR CUPOM POR CÓDIGO
===================================================== */

export const buscarCupomPorCodigo = async (code: string): Promise<ICupom> => {
  try {
    const response = await api.get<ICupom>(`/coupons/${code}`);
    return response.data;
  } catch (error: any) {
    console.error("Erro ao buscar cupom:",error?.response?.status);
    console.error("BODY:", error?.response?.data);
    throw error;
  }
};

/* =====================================================
   EXCLUIR CUPOM
===================================================== */

export const excluirCupom = async ( code: string): Promise<void> => {
  try { await api.delete(`/coupons/${code}`);
  } catch (error: any) {
    console.error( "Erro ao excluir cupom:", error?.response?.status);
    console.error("BODY:", error?.response?.data);
    throw error;
  }
};